import { useState } from "react";
import { UI } from "../constants/tokens";
import Icon from "./Icon";
import { withShekel } from "./DualMoney";

// ─── The detail behind a short label (sprint 16) ─────────────────────────────
// A small "i" after a short label. The detail is in the tooltip on hover, and
// a tap shows it under the label, the same way the rate under a shekel figure
// is shown (DualMoney). Used where a line of notes was spelling out what the
// label is measured by: the label stays one short line, and the reader opens
// the rest only when they want it.
//
// `text`: the detail, one string. `label`: what the button is named for a
// screen reader ("פרטים על ..."). The note is drawn by the caller when it needs
// to sit somewhere else: pass `open`/`onToggle` and render `text` yourself.
export default function InfoTip({ text, label = "פרטים", size = 14, color, open: openProp, onToggle, noteStyle, controls }) {
  const [openSelf, setOpenSelf] = useState(false);
  const controlled = openProp !== undefined;
  const open = controlled ? openProp : openSelf;
  const toggle = e => {
    e.stopPropagation();
    if (controlled) onToggle?.(!open); else setOpenSelf(o => !o);
  };
  return (
    <>
      <button type="button" onClick={toggle} title={text} aria-label={label} aria-expanded={open} aria-controls={controls}
        style={{
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          // A 25px target that takes no layout room, instead of the 44px phone
          // minimum for buttons (index.css), which would grow the label row.
          background: "transparent", border: "none", padding: 6, margin: -6, minHeight: 0,
          cursor: "pointer", verticalAlign: "middle", lineHeight: 0,
        }}>
        <Icon name="info" size={size} color={color || UI.text.muted}/>
      </button>
      {!controlled && open && (
        <span role="note" style={{ display: "block", fontSize: 12, fontWeight: 400, color: UI.text.secondary, lineHeight: 1.5, marginTop: 4, ...noteStyle }}>{withShekel(text)}</span>
      )}
    </>
  );
}
